import {authUserAPI} from '@/core/api';
import Loader from '@/shared/components/Loader';
import {useAppDispatch, useAppSelector} from '@/store/hooks';
import {getPrivateTicketsTiers} from '@/store/organization-tables';
import {getEvent} from '@/store/organization-event';
import {STORAGE_KEY} from '@/utils/enums';
import {getErrorMessage} from '@/utils/helpers';
import {userStorage} from '@/utils/services';
import {useEffect} from 'react';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {toast} from 'react-toastify';
import {getUserInfo, getUserSelector} from '@/store/user';

const PrivatePackageEntry = () => {
  const {eventId, token} = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const user = useAppSelector(getUserSelector);

  useEffect(() => {
    const load = async () => {
      if (!eventId || !token) {
        navigate('/');
        return;
      }

      let eventWebPage: string;
      try {
        const event = await dispatch(getEvent(eventId)).unwrap();
        eventWebPage = event.customizeWebpage;
      } catch (error) {
        toast.error(getErrorMessage(error));
        navigate('/');
        return;
      }

      const userId = userStorage.get<number>(STORAGE_KEY.USER_ID);

      if (!userId) {
        sessionStorage.setItem('private_return_to', location.pathname);
        navigate(`/${eventWebPage}`, {replace: true, state: {openLogin: true}});
        return;
      }

      if (!user) {
        try {
          await dispatch(getUserInfo(userId)).unwrap();
        } catch (error) {
          userStorage.remove(STORAGE_KEY.USER_ID);
          sessionStorage.setItem('private_return_to', location.pathname);
          navigate(`/${eventWebPage}`, {replace: true, state: {openLogin: true}});
          return;
        }
      }

      try {
        const data = {
          eventId: +eventId,
          token,
          apiInstance: authUserAPI,
        };
        await dispatch(getPrivateTicketsTiers(data)).unwrap();

        userStorage.set(STORAGE_KEY.PRIVATE_PURCHASE_TOKEN, token);
        navigate(`/${eventWebPage}/purchase-tickets`, {replace: true, state: {fromPrivateLink: true}});
      } catch (error) {
        toast.error(getErrorMessage(error));
        navigate(`/${eventWebPage}`, {replace: true});
      }
    };

    load();
  }, [eventId, token, user]);

  return <Loader />;
};

export default PrivatePackageEntry;
